import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { IconAlertTriangle, IconCurrencyDong, IconTruck, IconUser } from '@tabler/icons-react';
import s from './tabs.module.css';

// Mint-Mov-Phone · thanh "Tab chính": Chuyến · Chi phí · Báo sự cố · Cá nhân (TABS của board).
const TABS = [
  { to: '/mov', label: 'Chuyến', icon: IconTruck, match: ['/mov', '/mov/trip'] },
  { to: '/mov/cost', label: 'Chi phí', icon: IconCurrencyDong, match: ['/mov/cost'] },
  { to: '/mov/incident', label: 'Báo sự cố', icon: IconAlertTriangle, match: ['/mov/incident'], danger: true },
  { to: '/mov/me', label: 'Cá nhân', icon: IconUser, match: ['/mov/me', '/mov/vehicle'] },
] as const;

export function MovLayout() {
  const path = useRouterState({ select: (r) => r.location.pathname.replace(/\/$/, '') || '/' });
  // Phone2 khung 1 (Chụp ảnh) toàn màn, board không có thanh tab.
  if (path === '/mov/photo') return <Outlet />;
  return (
    <>
      <Outlet />
      <nav aria-label="Tab chính" className={s.bar}>
        {TABS.map((t) => {
          const on = (t.match as readonly string[]).includes(path);
          const Icon = t.icon;
          return (
            <Link key={t.to} to={t.to} className={`${s.tab} ${on ? s.on : ''} ${'danger' in t ? s.danger : ''}`} aria-current={on ? 'page' : undefined}>
              <Icon size={26} stroke={1.9} aria-hidden="true" />{t.label}
            </Link>
          );
        })}
      </nav>
    </>
  );
}
